import _find from 'lodash/find'
import _filter from 'lodash/filter'
import _includes from 'lodash/includes'
import _initial from 'lodash/initial'
import _last from 'lodash/last'

import HitSpread from './hit-spread/hit-spread'

import HitSequence from './hit-spread/hit_sequence'

function HitsView(gl, loop) {
    this.gl = gl
    this.loop = loop

    this.hitSpread = HitSpread.empty()

    this.saved = {}

    gl.add(this.hitSpread)
}

HitsView.prototype.getHitSpread = function () {
    return this.hitSpread
}

HitsView.prototype.clear = function () {
    this.hitSpread.showAll(0, 0)
    this.gl.tick()
}

HitsView.prototype.loadHits = function (hits) {
    const that = this

    // TODO    alternatively, add a clear method to HitSpread and keep one instance of it here

    // clear existing HitSpread and create a new one
    this.gl.clearMesh(this.hitSpread)
    this.hitSpread = HitSpread.empty()
    this.gl.add(this.hitSpread)

    hits.forEach((hit) => {
        const metrics = {
            ...hit.result.computedMetrics,
            playerName: hit.playerName,
            round: hit.round,
            summary: hit.summary,
        }
        that.hitSpread.addHit(hit, {
            meta: metrics,
            opacity: 1, // .5
        })
    })

    this.hitSpread.showAll(0, 0)

    return this
}

HitsView.prototype.highlightHits = function (highlightedPlayIds) {
    const that = this

    function saveObjectTransparency(obj) {
        that.saved[obj.uuid] = {
            transparent: obj.material.transparent,
            opacity: obj.material.opacity,
            depthWrite: obj.material.depthWrite,
        }
    }

    function restoreObjectTransparency(obj) {
        const saved = that.saved[obj.uuid]

        if (saved) {
            // obj.material.transparent = saved.transparent;
            obj.material.opacity = saved.opacity
            obj.material.depthWrite = saved.depthWrite

            delete that.saved[obj.uuid]
        }
    }

    function setHitTransparency(hit, transparency) {
        if (!hit?.children) {
            return
        }
        hit.children.forEach((obj) => {
            const mat = obj.material

            saveObjectTransparency(obj)

            // mat.transparent = true;
            mat.opacity = transparency
            mat.depthWrite = false
        })
    }

    function saveHitTransparency(hit) {
        hit.children.forEach(saveObjectTransparency)
    }

    function restoreHitTransparency(hit) {
        hit.children.forEach(restoreObjectTransparency)
    }

    function saveAll() {
        const hitObjects = that.hitSpread.getHitObjects()

        hitObjects.forEach(saveHitTransparency)
    }

    function restoreAll() {
        const hitObjects = that.hitSpread.getHitObjects()

        hitObjects.forEach(restoreHitTransparency)
        that.gl.tick()
    }

    const doHighlight = highlightedPlayIds && highlightedPlayIds.length > 0
    let hitObjects
    let highlghtedHitObjects
    let unhighlightedHitObjects

    restoreAll()
    // saveAll();

    if (doHighlight) {
        hitObjects = this.hitSpread.getHitObjects()
        highlghtedHitObjects = highlightedPlayIds.map((playId) =>
            _find(
                hitObjects,
                (hitObject) => hitObject.userData.playId === playId
            )
        )
        unhighlightedHitObjects = _filter(
            hitObjects,
            (hitObject) =>
                !_includes(highlightedPlayIds, hitObject.userData.playId)
        )

        unhighlightedHitObjects.forEach((hitObject) => {
            setHitTransparency(hitObject, 0.15)
        })
        highlghtedHitObjects.forEach((hitObject) => {
            setHitTransparency(hitObject, 1)
        })
        // } else {
        //     // no hits to highlight, restore all
        //     restore();
    }
    this.gl.tick()
}

/**
 * Compares with existing hit objects to determine new hits, then adds and fires them.
 * @param hits
 * @returns {HitsView}
 */
HitsView.prototype.addHits = function (hits) {
    const that = this
    const currentHitObjects = this.hitSpread.getHitObjects()
    const currentHitObjectIds = currentHitObjects.map(
        (hitObject) => hitObject.userData.playId
    )
    const newHits = _filter(
        hits,
        (h) => !_includes(currentHitObjectIds, h.playId)
    )
    const newHitsIds = newHits.map((hit) => hit.playId)
    const headHits = _initial(newHits)
    const tailHit = _last(newHits)
    let headHitObjects
    let tailHitObject
    let headSequence
    let tailSequence

    // TODOHI  consolidate with hitObject creation params elsewhere
    function toHitObject(hit) {
        const metrics = hit.result.computedMetrics
        const hitObject = that.hitSpread.addHit(hit, {
            meta: metrics,
            opacity: 1, // .5
        })

        // hitObject.show(0, 1);
        hitObject.show(0, 0)

        return hitObject
    }

    function sequenceEnded() {
        console.log('sequenceEnded - loop count:', that.loop.state.activeCount)
    }

    // TODOHI  highlight MRH
    function fireTailHit(dur) {
        dur = dur || 3000

        tailSequence = HitSequence.simultaneous([tailHitObject], that.loop, dur)
            .start()
            .onSequenceEnd(sequenceEnded)
    }

    if (newHits.length > 0) {
        console.log(
            `-------------------------------------------------------------------> fire new hits - head: ${headHits.length}, total: ${newHits.length}`
        )

        if (headHits.length > 0) {
            headHitObjects = headHits.map(toHitObject)
        }
        tailHitObject = toHitObject(tailHit)

        if (headHits.length > 0) {
            headSequence = HitSequence.simultaneous(
                headHitObjects,
                this.loop,
                1000
            )
                .onSequenceEnd(fireTailHit)
                .start()
        } else {
            fireTailHit(4000)
        }
    } else {
        // This can happen if a previous round is updated while the live round is going on
        // The delta includes all HRs from all rounds
        console.warn('addHits called, but no new hits')
        console.log(`  currentHitObjects: ${currentHitObjects.length}`)
        console.log(`            newHits: ${newHits.length}`)
        console.log(`currentHitObjectIds: ${currentHitObjectIds.join(', ')}`)
        console.log(`          newHitIds: ${newHitsIds.join(', ')}`)
        console.log('hits:', hits)
    }

    return this
}

export default HitsView
